import { MILLISECONDS_IN_SECOND } from '@/utils/constants/time-constants';

const SECONDS_BEFORE_CLOSE = 10;

export const state = () => ({
  alerts: [],
});

export const mutations = {
  open(state, alert) {
    state.alerts = [...state.alerts, alert];
  },
  close(state, id) {
    state.alerts = state.alerts.filter((alert) => alert.id !== id);
  },
};

export const actions = {
  // {
  //  type: ['success', 'info', 'warning', 'error']
  //  text: 'Text bla bla bla'
  //  primaryAction: function,
  //  primaryActionText: текст для основной кнопки
  //  secondaryAction: function,
  //  secondaryActionText: текст для второстепенной кнопки,
  //  timeout: время до закрытия, по умолчанию 10, false если не закрывать
  //  loader: true если нужно крутить спиннер в алерте
  // }
  // Возвращает промис c айди алерта, чтобы извне можно было совершать действия (закрыть пока что)
  // const alertId = await showAlert(...);
  showAlert({ commit }, alert) {
    const id = new Date().getTime();
    commit('open', { ...alert, id });

    if (alert.timeout !== false) {
      setTimeout(() => {
        commit('close', id);
      }, (alert.timeout || SECONDS_BEFORE_CLOSE) * MILLISECONDS_IN_SECOND);
    }

    return id;
  },
  closeAlert({ commit }, id) {
    commit('close', id);
  },
};

export default { namespaced: true, state, mutations, actions };
